export enum MediaType {

    /**
     * The application type (data over bridge channel).
     */
    APPLICATION = 'application',

    /**
     * The audio type.
     */
    AUDIO = 'audio',

    /**
     * The desktop video type.
     */
    DESKTOP = 'desktop',

    /**
     * The video type.
     */
    VIDEO = 'video'
}
